module.exports = __webpack_public_path__ + "static/media/schody51 - schody drewniane czarne z oswietleniem pod stopniami.c9b06684.jpg";